export var PolygonMaskType;
(function (PolygonMaskType) {
    PolygonMaskType["inline"] = "inline";
    PolygonMaskType["inside"] = "inside";
    PolygonMaskType["outside"] = "outside";
    PolygonMaskType["none"] = "none";
})(PolygonMaskType || (PolygonMaskType = {}));
